import { createFileRoute } from "@tanstack/react-router"

import { redirectRoot } from "@/lib/route-guards"

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    redirectRoot(context)
  },
  component: () => null,
})
